module.exports = __webpack_public_path__ + "img/2.8482a548.jpg";